module.exports = __webpack_public_path__ + "static/img/30.440af7bf.png";